import { Button } from '#atoms';
import { SetStateAction } from 'react';
import { useNavigate } from 'react-router';
import styled from 'styled-components';
import { Container, Label } from './styles';

interface PortfolioModalProps {
  onClose: () => void;
}

export const PortfolioListModal = ({ onClose }: PortfolioModalProps) => {
  const navigate = useNavigate();
  return (
    <Container>
      <Label>트레이닝 성과 만들기</Label>
      <Button size="sm" onClick={() => navigate('/portfolio/chartList')}>
        운동차트 불러오기
      </Button>
      <Button
        size="sm"
        background="anti"
        style={{ color: '#e13a3a' }}
        onClick={() => navigate('/portfolio')}
      >
        직접 작성하기
      </Button>
      <Button size="sm" background="transparent" onClick={onClose}>
        닫기
      </Button>
    </Container>
  );
};
